export default __webpack_public_path__ + "static/media/ic_services.549708ca.svg";